import Vue from 'vue'
import App from './App.vue'

import ElementUi from 'element-ui'
Vue.use(ElementUi)
import 'element-ui/lib/theme-chalk/index.css'

import VueRouter from 'vue-router';
Vue.use(VueRouter)

import axios from 'axios';
Vue.prototype.$http = axios

import htRem from '../src/js/htRem';
Vue.use(htRem)

import store from '../src/store/store'
import router from '../src/router/index'

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import { VDistpicker } from 'v-distpicker';
// Vue.use(VDistpicker)
export default{
  component: { VDistpicker }
}

import XLSX from 'xlsx'
import toExcel from './excel/Export2Excel';

Vue.prototype.$toExcel = toExcel
// import Blob from './excel/Blob'
// import Export2Excel from './excel/Export2Excel'
require('script-loader!file-saver'); //保存文件用
//require('script-loader!vendor/Blob'); //转二进制用
require('script-loader!xlsx/dist/xlsx.core.min'); //xlsx核心
Vue.prototype.XLSX = XLSX

import Print from 'vue-print-nb'
Vue.use(Print);

import htmlToPdf from './excel/htmlToPdf'
Vue.use(htmlToPdf)
import Share from 'vue-social-share'
 
import 'social-share.js/dist/css/share.min.css';
import '../node_modules/social-share.js/dist/js/social-share.min.js'
 
Vue.use(Share)


Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'typeId') {

      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              sessionStorage.setItem(k, val);

              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}
Vue.prototype.resetSetRecomId = function (key, newVal) {
  if (key === 'recommendIds') {
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              sessionStorage.setItem(k, val);
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}

router.beforeEach((to, from, next) => {
  // 路由跳转后，让页面回到顶部
  // chrome
  document.body.scrollTop = 0; // firefox
  document.documentElement.scrollTop = 0; // safari
  window.pageYOffset = 0; // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next();
  //to 即将进入的路由
  //from 即将离开的路由
  //next 放行
});
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
}).$mount('#app')
